import React, { Fragment } from 'react'
import { Breadcrumbs } from '../../../../../AbstractElements';
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import TenantItemwiseView from './TenantItemwiseView';

const TenantItemwiseReport = () => {
    return (
        <Fragment>
            <Breadcrumbs parent="Report" title="Tenant Itemwise Report" mainTitle="Tenant Itemwise Report" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <TenantItemwiseView />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default TenantItemwiseReport